const scrollNavItem = document.querySelectorAll('.anchor-link-js');
const scrollSections = document.querySelectorAll('.newsletter');
const postContentSectionAnchors = document.querySelectorAll(`.single-post__content a[href$="source"]`);

// Scroll to Newsletter form
function scrollSection(links) {
    [ ...links ].forEach(link => {
        link.addEventListener('click', function H(el) {
            const hash = this.hash.replace('#', '');

            if (scrollSections.length !== 0) {
                el.preventDefault();
                el.stopPropagation();

                $('html, body').animate({
                    scrollTop: $(`[data-scroll="${hash}"]`).offset().top - 78
                }, 1000);
            }

            if(document.querySelector('.page-header').classList.contains('open')) {
                document.querySelector('.page-header__inner').classList.remove('open');
                document.querySelector('.page-header').classList.remove('open');
                document.querySelector('.page-body').classList.remove('show');
                document.querySelector('.burger-wrapper').classList.remove('open');
            }
        });
    });
}
scrollSection(scrollNavItem);

// Scroll to Newsletter form with hash on page load
window.addEventListener('load', () => {
    const hash = location.hash.replace('#', '');

    if (hash !== '' && document.querySelector('.newsletter')) {
        $('html, body').animate({
            scrollTop: $(`[data-scroll="${hash}"]`).offset().top - 78
        }, 1000, () => {
            history.pushState('', document.title, window.location.pathname);
        });
    }
});

// Scroll to Source section on post anchor click
postContentSectionAnchors.forEach(link => {
   link.addEventListener('click', el=> {
       el.preventDefault();

       $('html, body').animate({
           scrollTop: $(`[data-source="source"]`).offset().top - 100
       }, 1000);
   });
});
